export enum LabelDisplayOption {
	LABEL_ONLY = 0,
	LABEL_WITH_SCORE = 1,
}

